<template>
    <div>
        <div v-if="product">
            <div class="content">
                <jabra-breadcrumbs></jabra-breadcrumbs>
                <div class="item-section">
                    <div class="image-section">
                        <div class="frame">
                            <img src="../assets/images/talmud_item.png" alt="talmud_item">
                        </div>
                    </div>
                    <div class="info-section">
                        <div class="header"><span>{{product.name}}</span></div>
                        <div class="divider"></div>
                        <div class="product-price-range-container">
                            <span class="product-price-range">
                                <span>{{minPrice(product)}}$</span>
                                <span>-</span>
                                <span>{{maxPrice(product)}}$</span>
                            </span>
                        </div>
                        <div class="product-subtitle">
                            <div v-html="product.description"></div>
                        </div>
                        <div v-for="variant in product.variant">
                            <div class="size-description">
                                <div class="size-name">
                                    <span>{{variant.short_name}}</span>
                                </div>
                                <div class="size-details">
                                    <div class="jabra-long-text">
                                        <div v-html="variant.details"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="action-section">
                            <div class="select-section">
                                <div class="select-header">
                                    <span>select size</span>
                                </div>
                                <div class="select-area">
                                    <div>
                                        <jabra-dropdown :data="variantLabels(product)"
                                                        v-on:jbr-select="selectVariant($event)"></jabra-dropdown>
                                    </div>
                                    <div class="stepper-container">
                                        <jabra-stepper
                                                v-on:sfr-stepper-change="selectedQuantity = $event"></jabra-stepper>
                                    </div>
                                </div>
                            </div>
                            <div class="add-to-cart-section">
                                <jabra-btn dark v-on:jbr-click="addToCart()" :disabled="!selectedVariant">
                                    <span class="add-to-cart-span">Add To Cart</span>
                                </jabra-btn>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
            <div class="bottom-colored-section-container">
                <div class="bottom-colored-section">
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {
        LOAD_BOOK_PRODUCTS,
        LOAD_TALMUD_PRODUCTS,
        LOADING_STARTED,
        ROUTE_STORE_SIDDER,
        ROUTE_STORE_TALMUD_ITEM,
        ADD_TO_CART,
        CATEGORY_TALMUD,
        CATEGORY_SIDDUR,
    } from '../services/constants'
    import helpers from '../services/helpers'

    export default {
        name: 'store-item-component',
        data: function () {
            return {
                LOADING_STARTED: LOADING_STARTED,
                ROUTE_STORE_TALMUD_ITEM: ROUTE_STORE_TALMUD_ITEM,
                selectedVariant: null,
                selectedQuantity: null,
            }
        },
        computed: {
            product() {
                let products = null
                switch (this.storeMode) {
                    case ROUTE_STORE_SIDDER:
                        products = this.$store.state.commerceModule.bookProducts.data
                        if (products && products.length > 0) {
                            return products[0]
                        } else {
                            return null
                        }
                    case ROUTE_STORE_TALMUD_ITEM:
                        products = this.$store.state.commerceModule.talmudProducts.data
                        if (products) {
                            const result = products.find(product => {
                                return product.id.toString() === this.$route.params.id
                            })
                            return result ? result : null
                        } else {
                            return null
                        }
                    default:
                        return products
                }
            },
            language() {
                return this.$store.state.languageModule.currentLanguage
            },
            storeMode() {
                return this.$route.name
            },
            masechetNamePrefix() {
                return this.$store.state.commerceModule.masechetNamePrefix
            }
        },
        watch: {
            language(newVal) {
                this.init()
            }
        },
        methods: {
            minPrice(product) {
                return helpers.minPrice(product)
            },
            maxPrice(product) {
                return helpers.maxPrice(product)
            },
            variantLabels(product) {
                return helpers.variantLabels(product)
            },
            selectVariant(variantShortName) {
                this.selectedVariant = this.product.variant.find(eachVariant => {
                    return eachVariant.short_name === variantShortName
                })
            },
            addToCart() {
                const productForCart = {
                    productId: this.product.id,
                    item: this.storeMode === ROUTE_STORE_TALMUD_ITEM ? CATEGORY_TALMUD : CATEGORY_SIDDUR,
                    name: this.storeMode === ROUTE_STORE_TALMUD_ITEM ?
                        `${this.masechetNamePrefix} ${this.product.name}` : 'Sidur',
                    variant: this.selectedVariant.short_name,
                    unitPrice: this.selectedVariant.price,
                    quantity: this.selectedQuantity,
                }
                this.$store.dispatch(ADD_TO_CART, productForCart)
            },
            init() {
                if (this.language) {
                    switch (this.storeMode) {
                        case ROUTE_STORE_SIDDER:
                            this.$store.dispatch(LOAD_BOOK_PRODUCTS)
                            break
                        case ROUTE_STORE_TALMUD_ITEM:
                            this.$store.dispatch(LOAD_TALMUD_PRODUCTS)
                            break
                        default:
                            break
                    }
                }
            }
        },
        created() {
            this.init()
        },
    }
</script>

<style scoped lang="scss">
    @import "../scss/main";

    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 70px 245px 75px;
    }

    .header {
        text-transform: uppercase;
        @include font-abraham(50px, $font-color-blue, 400);
    }

    .divider {
        width: 120px;
        height: 8px;
        margin: 15px 0;
        background: $accent-1;
    }

    .item-section {
        margin: 45px 0 0 0;
        width: 100%;
        display: flex;
    }

    .image-section {
        margin: 0 140px 0 0;
    }

    .frame {
        border: #dce9ef solid 3px;
        background: white;
        height: calc(100% - 200px);
        display: flex;
        align-items: center;
    }

    .bottom-colored-section-container {
        z-index: -1;
        position: relative;
    }

    .bottom-colored-section {
        background: rgba(220, 233, 239, 0.37);
        height: 330px;
        width: 100%;
        position: absolute;
        bottom: 0;
    }

    .product-price-range-container {
        margin: 40px 0;
    }

    .product-price-range {
        background: $accent-2;
        padding: 0 15px;
        @include font-abraham(28px, $font-color-blue, 400);
    }

    .product-subtitle {
        @include font-abraham(30px, $font-color-blue, 300);
    }

    .size-description {
        @include font-abraham(24px, $font-color-blue, 500);
        padding: 25px 0;
    }

    .size-details {
        @include font-abraham(24px, $font-color-blue, 300);
        line-height: 36px;
    }

    .action-section {
        padding: 116px 0 0 0;
    }

    .select-header {
        @include font-abraham(16px, $grey-1, 400);
        padding: 15px 0;
    }

    .select-area {
        display: flex;
    }

    .stepper-container {
        padding: 0 0 0 25px;
    }

    .add-to-cart-section {
        padding: 50px 0 0 0;
    }

    .add-to-cart-span {
        font-size: 20px;
        line-height: 50px;
        padding: 0 30px;
    }

</style>
